<template>
  <b-modal
    id="delete-account-modal"
    title="Are you sure you want to delete your account?"
    centered
  >
    <b-overlay :show="loading" spinner-variant="primary">
      <div class="message" v-show="!loading">
        Deleting your account is permanent and you’ll be logged out immediately.
      </div>
    </b-overlay>
    <template slot="modal-footer">
      <div class="d-flex justify-content-end">
        <b-btn
          variant="link"
          class="cancel-delete-button"
          @click="$root.$emit('bv::hide::modal', 'delete-account-modal')"
          :disabled="loading"
        >
          No, don't delete it
        </b-btn>
        <b-btn
          class="confirm-delete-button"
          pill
          @click="confirmDeleteAccount"
          :disabled="loading"
        >
          Yes, I'm sure
        </b-btn>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    async confirmDeleteAccount() {
      await this.getDeleteAccountStatus();

      if (this.canDeleteAccount) {
        await this.deleteAccount();
        this.$root.$emit("bv::hide::modal", "delete-account-modal");

        if (this.errors) {
          this.$root.$emit("bv::show::modal", "failed-delete-account-modal");
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$root.$emit("bv::show::modal", "account-deleted-modal");
        }
      } else {
        this.$root.$emit("bv::hide::modal", "delete-account-modal");
        this.$root.$emit("bv::show::modal", "failed-delete-account-modal");
      }
    },
    async deleteAccount() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          deactivation_channel: "web",
        },
      };

      await this.$store.dispatch("customer/deleteAccount", request);
    },
    async getDeleteAccountStatus() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
        },
      };

      await this.$store.dispatch("estore/getDeleteAccountStatus", request);
    },
  },
  computed: {
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("auth", ["token", "user"]),
    ...mapState("customer", ["loading", "errors"]),
    ...mapState("estore", {
      canDeleteAccount: (state) => state.deleteAccountStatus,
    }),
  },
};
</script>

<style lang="scss">
#delete-account-modal {
  .modal-dialog {
    max-width: 432px !important;
  }
  .modal-header {
    padding-top: 20px;
    padding-bottom: 0;
    border-bottom-width: 0;
  }
  .modal-footer {
    border-top-width: 0;
    padding-bottom: 25px;
  }
  .modal-title {
    padding-left: 25px;
    padding-right: 25px;
  }
  .modal-content {
    border-radius: 8px;
  }
  .message {
    color: #ff2d2d;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 14px;
  }
  .cancel-delete-button {
    color: #68737d;
    text-decoration: none;
    font-size: 14px;
    margin-right: 10px;
  }
  .confirm-delete-button {
    background-color: #ff2d2d;
    color: #ffffff;
    border-width: 0;
    padding: 11px 30px;
    font-size: 14px;
    @extend .mainFontBold;
    &:hover,
    &:focus {
      filter: brightness(95%);
    }
  }
  button:focus {
    outline-width: 0;
  }
}
</style>